// WO 5 — entity-type confirm widget. Renders two cards (Private
// Limited / OPC) at the end of STRUCTURE_GUIDANCE. The founder's
// choice is committed deterministically via /cases/{id}/entity-type-confirm
// — the LLM is never involved in this decision.

import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function EntityTypeConfirmWidget({
  options, busy, onSelect,
}) {
  const [picked, setPicked] = useState(null);

  return (
    <div
      data-testid="entity-type-confirm-widget"
      className="mt-3 bg-white border border-slate-200 rounded-xl p-4 shadow-sm"
    >
      <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-3">
        Confirm company type
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {(options || []).map((opt) => {
          const active = picked === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => setPicked(opt.value)}
              data-testid={`entity-type-option-${opt.value}`}
              disabled={busy}
              className={[
                "text-left border rounded-xl p-4 transition-colors",
                active
                  ? "border-[#C5283F] bg-[#C5283F]/5 ring-1 ring-[#C5283F]/40"
                  : "border-slate-300 hover:border-[#C5283F]",
                busy ? "opacity-60 cursor-not-allowed" : "",
              ].join(" ")}
            >
              <div className="flex items-center justify-between mb-1">
                <div className="font-semibold text-slate-900 text-sm">
                  {opt.label}
                </div>
                {active && (
                  <CheckCircle2 size={16} className="text-[#C5283F]" />
                )}
              </div>
              <div className="text-xs text-slate-600 leading-snug">
                {opt.blurb}
              </div>
            </button>
          );
        })}
      </div>
      <button
        type="button"
        onClick={() => picked && onSelect(picked)}
        disabled={busy || !picked}
        data-testid="entity-type-confirm-submit-btn"
        className="mt-4 w-full bg-[#C5283F] text-white rounded-lg py-2.5 text-sm font-medium hover:bg-[#A82035] disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2"
      >
        {busy ? (
          <>
            <Loader2 size={14} className="animate-spin" /> Locking choice…
          </>
        ) : (
          <>Confirm and continue</>
        )}
      </button>
      <div className="mt-2 text-[11px] text-slate-500 text-center">
        This choice is locked once confirmed — contact us if you need
        to change it later.
      </div>
    </div>
  );
}
